import { render } from "./Table.vue?vue&type=template&id=2286330b&scoped=true"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-2286330b"

export default script